/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Demand_Type_CommercialInputs */

const cs_public_site_demand_type_commercial = /** @type {(inputs: Public_Site_Demand_Type_CommercialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komerční`)
};

const en_public_site_demand_type_commercial = /** @type {(inputs: Public_Site_Demand_Type_CommercialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commercial`)
};

/**
* | output |
* | --- |
* | "Commercial" |
*
* @param {Public_Site_Demand_Type_CommercialInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_demand_type_commercial = /** @type {((inputs?: Public_Site_Demand_Type_CommercialInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Demand_Type_CommercialInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_demand_type_commercial(inputs)
	return cs_public_site_demand_type_commercial(inputs)
});